var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTodoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bottom-bar-to-do",
    transform: "translate(3 3.237)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blankbox",
    width: 16,
    height: 16,
    transform: "translate(-3 -3.237)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4502",
    "data-name": "Path 4502",
    d: "M45.164,28.161a.412.412,0,0,1-.376.224H35.5a.429.429,0,0,1-.36-.662l.5-.77a1.2,1.2,0,0,0,.2-.668V24.008a4.31,4.31,0,1,1,8.619,0v2.276a1.2,1.2,0,0,0,.2.668l.5.77A.412.412,0,0,1,45.164,28.161Zm-3.9,1.381a1.125,1.125,0,0,1-2.251,0v-.356h2.251Zm4.553-2.254-.5-.77a.4.4,0,0,1-.069-.233V24.008a5.111,5.111,0,0,0-10.222,0v2.276a.4.4,0,0,1-.069.233l-.5.77a1.23,1.23,0,0,0,1.033,1.9h2.719v.356a1.927,1.927,0,0,0,3.853,0v-.356h2.719a1.23,1.23,0,0,0,1.032-1.9Z",
    transform: "translate(-34.978 -20.42)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoIcon);
export default __webpack_public_path__ + "static/media/todo-icon.6cdc613a6fe90a46f619f62efdffaae8.svg";
export { ForwardRef as ReactComponent };